export default __webpack_public_path__ + "static/media/logo.47a92fa3.svg";